/**
 * @ngdoc Directive
 * @name vrmUpload
 * @example
 *
 *
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmUpload', vrmUpload);

    /* @ngInject */
    function vrmUpload($log) {

        var definition = {
            restrict: 'E',
            template: require('@/angular/modules/vrm-components/modal/upload/upload.template.html'),
            link: link,
            transclude: true,
            scope: {
                uploadCallback: '=',
                type: '='
            }
        };

        return definition;

        /**
         * Link
         * @param $scope
         * @param $element
         * @param $attr
         */
        function link($scope, $element, $attr) {
            var elButton = $element.find('.vrm-upload--button');
            elButton.on('click', function(e) {
                $element.find('input[type=file]')[0].click();
                e.preventDefault();
            });
            $element.find('input[type=file]').on('change', function() {
                $scope.uploadCallback(this.files);
            });

            var elDrop = $element.find('.vrm-upload--drop');
            elDrop.on('dragenter', function(e) {
                e.preventDefault();
                e.stopPropagation();

                elDrop.addClass('vrm-upload--drop__hover');
            });
            elDrop.on('dragleave', function(e) {
                e.preventDefault();
                e.stopPropagation();

                elDrop.removeClass('vrm-upload--drop__hover');
            });
            elDrop.on('drop', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var files = e.target.files || e.dataTransfer.files;

                // process all File objects
                $scope.uploadCallback(files);
            });

            $scope.getAcceptedMIME = function () {
                switch ($scope.type) {
                    case 'avatar':
                        return 'image/*';
                    case 'photo':
                        return 'image/*';
                    case 'firmware_dup':
                        return '.dup,.xup';
                    case 'firmware_vup':
                        return '.vup,.xup';
                    case 'firmware_vff':
                        return '.vff';
                    case 'firmware_evcsup':
                        return '.evcsup';
                    case 'veconf':
                        return '.rvsc,.rvms';
                    default:
                        return '*/*';
                }
            }
        }
    }
})();
